import { IUserSettingsState } from '../../store/userSettings/store';
import {
  getRelativeUrlData
} from '../location/locationService';

export const getIdTokenFromUrl = (): string | undefined => {
  try {
    const idTokenHref = getRelativeUrlData()?.id_token;
    if (idTokenHref) {
      return idTokenHref;
    }
  } catch (e) {
    console.error(e);
  }
  return undefined;
};

export const isSwitchingPortals = (): boolean => {
  try {
    const switchToParameter = getRelativeUrlData()?.switchTo;
    if (switchToParameter) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.error(e);
  }
  return false;
};

export const getCurrentIdToken = () => {
  const currentIdToken = localStorage.getItem('idToken');
  return currentIdToken && currentIdToken.length > 0 ? currentIdToken : null;
};

export const setCurrentIdToken = (idToken: string | null) => {
  localStorage.setItem('idToken', idToken ?? '');
};

export const isUserAuthorized = (
  userSettings: IUserSettingsState,
  webFeatures: string[]
): boolean =>
  webFeatures.every(
    (_webFeature) =>
      (userSettings.userSettings?.webFeatures.indexOf(_webFeature as any) ||
        -1) > -1
  );
